module.exports = __webpack_public_path__ + "img/logo_white.7828bf8b.svg";